import type { ExperienceType } from "@intelligems/ig-types/dtos/experiences";

// These experiences give each test group its own modifications, edited on
// that group's tab, instead of one set that every group shares.
const PER_GROUP_MOD_TYPES: ReadonlySet<ExperienceType> = new Set([
  "personalization/offer",
  "checkoutBlock",
  "postPurchase",
]);

export const hasPerGroupMods = (type: ExperienceType | undefined) =>
  type !== undefined && PER_GROUP_MOD_TYPES.has(type);
